module.exports = __webpack_public_path__ + "static/sanmateo-00a816cbdcdbda0a4adb6642355b642d.jpg";